<div class="-m-6 w-80 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-700 p-4">
    <div class="flex items-center gap-3">
        <span class="w-5 h-5 rounded-full border-2 border-primary-200 dark:border-primary-800 border-t-primary-600 animate-spin shrink-0"></span>
        <span class="text-sm font-semibold text-gray-900 dark:text-white">Checking this computer…</span>
    </div>
    <p class="text-xs text-gray-500 dark:text-gray-400 mt-2">
        Looking for LollyDrive on your computer{{ (desktopAgentService.currentFileName$ | async) ? ' so we can open "' + (desktopAgentService.currentFileName$ | async) + '" there' : '' }}.
    </p>
</div>
